import { t, Trans } from '@lingui/macro'
import { AddCircle } from '@material-ui/icons'
import { useLocations } from 'context'
import { navigate } from 'helpers'
import React from 'react'
import {
  Button,
  Flex,
  FlexAlignItemsCenter,
  IconButton,
  InputField,
  Loading,
  Option,
} from 'webbook-airways'

export default function InputFieldLocations({
  value: valueProp,
  onChange,
  required,
  withoutAll,
  disabled,
  withAdd = false,
}) {
  const { loading, locations } = useLocations()

  const value = React.useMemo(() => {
    if (!valueProp) return undefined
    const findLocation = locations?.find(
      (location) => location.location_id === valueProp,
    )
    if (findLocation) return valueProp
    if (valueProp.includes('T-')) {
      const findTemporaryLocation = locations?.find(
        (location) =>
          location.location_id === `E-${valueProp.replace('T-', '')}`,
      )
      if (findTemporaryLocation) return findTemporaryLocation.location_id
    }
    if (valueProp.includes('D-')) {
      const findTemporaryLocation = locations?.find(
        (location) =>
          location.location_data_id ===
          Number(`${valueProp.replace('D-', '')}`),
      )
      if (findTemporaryLocation) return findTemporaryLocation.location_id
    }
    return undefined
  }, [valueProp, locations])

  if (loading) {
    return (
      <FlexAlignItemsCenter css={{ justifyContent: 'center', minWidth: 100 }}>
        <Loading size={20} container={false} noTimeout />
      </FlexAlignItemsCenter>
    )
  }

  if (locations?.length < 1) {
    return (
      <Button
        onClick={() => navigate('/booking/setup/addresses/1')}
        variant="outlined"
        style={{ margin: 5, width: '100%' }}
      >
        <Trans>No addresses found, create at least one</Trans>
      </Button>
    )
  }

  return (
    <Flex style={{ alignItems: 'center' }}>
      <InputField
        label={<Trans>Address</Trans>}
        value={value}
        onChange={onChange}
        required={required}
        noEmpty={!withoutAll}
        disabled={disabled}
      >
        {!withoutAll && <Option value="all">{t`All`}</Option>}
        {locations?.map((location) => {
          return (
            <option key={location.location_id} value={location.location_id}>
              {location.place}
              {' - '}
              {location?.street?.length > 20
                ? location.street.substring(0, 20) + '...'
                : location.street}
              {', '}
              {location?.city?.substring(0, 10)}
            </option>
          )
        })}
      </InputField>
      {withAdd && (
        <IconButton
          icon={AddCircle}
          onClick={() => navigate('/staff/setup/locations')}
        />
      )}
    </Flex>
  )
}
